<template>
    <RouterView />
</template>

<script>
</script>

<style lang="scss">
button:focus {
    box-shadow: none !important;
}

* {
    touch-action: pan-x pan-y;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}

html, body {
    overscroll-behavior: none;
}
</style>